// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__k0QaV","title":"AfterFrontImage_title__1MQGZ"};